import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  listenToHostShortstays,
  upsertShortstay,
  deleteShortstay,
} from "../../../redux/shortstaysSlice";

import {
  listenToUserCommercePartners,
} from "../../../redux/commercePartnersSlice";

import { AppDispatch, RootState } from "../../../redux/store";

import {
  AddCircleOutline,
  MoreVert,
  Star,
  Edit,
  CheckCircle,
  Delete,
  PushPin,
} from "@mui/icons-material";

import { useCurrency } from "@cosmoola/react-cosmoola-js";




const getRateLabel = (rateType?: string) => {
  switch (rateType) {
    case "perNightPerPerson": return "person / night";
    case "perHourPerPerson":  return "person / hour";
    case "perHour":           return "hour";
    case "perWeek":           return "week";
    case "perMonth":          return "month";
    case "perYear":           return "year";
    case "perNight":
    default:                  return "night";
  }
};

const getDiscountMultiplier = (listing: any) => {
  const d = listing.discounts;
  if (!d) return 1;

  if (d.is80) return 0.2;
  if (d.is50) return 0.5;
  if (d.is25) return 0.75;
  if (d.is10) return 0.9;
  if (d.is5) return 0.95;

  return 1;
};

const ShortListings: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const userId = useSelector((state: RootState) => state.auth.user?.uid);
const user = useSelector((state: RootState) => state.auth.user); // ✅ add this
  const { listings, loading, error } = useSelector(
    (state: RootState) => state.shortstays
  );

  // ✅ NEW SLICE
  const commercePartners = useSelector(
    (state: RootState) => state.commercePartners.partners
  );

  const commerceLoading = useSelector(
    (state: RootState) => state.commercePartners.loading
  );

  
  const shortstayBrandId = (commercePartners as any[]).find(
    (p) => Number(p.categoryId) === 2 && Number(p.subcategoryId) === 203
  )?.brandId;

const { convertRaw, symbol } = useCurrency();

  const [menuVisible, setMenuVisible] = useState<string | null>(null);

  /* ---------------- LISTEN TO COMMERCE PARTNERS ---------------- */
  useEffect(() => {
    if (!userId) return;
    dispatch(listenToUserCommercePartners(userId));
  }, [dispatch, userId]);

  /* ---------------- REDIRECT IF NO BRAND ---------------- */
  useEffect(() => {
    if (!userId) return;
    if (commerceLoading) return;

    //if (commercePartners.length === 0) {
    //  navigate(`/CommerceOnboarding`, { replace: true });
   // }

   if (commercePartners.length === 0 &&  user?.isCommercePartner) {
  navigate(`/onboarding`, { replace: true });
}
  }, [commercePartners, commerceLoading, userId, navigate]);

  /* ---------------- LISTEN TO SHORTSTAYS ---------------- */
  useEffect(() => {
    dispatch(listenToHostShortstays());
  }, [dispatch]);

  const handleAction = async (listingId: string, action: string) => {
    if (action === "publish") {
      await dispatch(
        upsertShortstay({
          listingId,
          data: {
            isDraft: false,
            inReview: true,
            ...(shortstayBrandId ? { operatorId: shortstayBrandId } : {}),
          },
        })
      );
    } else if (action === "delete") {
      await dispatch(deleteShortstay(listingId));
    } else if (action === "edit") {
      navigate(`/shortstaysedit/${listingId}`);
    }
    setMenuVisible(null);
  };

  const getStatus = (listing: any) => {
    if (listing.isFlagged) return { label: "Flagged", color: "#d32f2f" };
    if (listing.isPublished) return { label: "Published", color: "#00c853" };
    if (listing.inReview) return { label: "In Review", color: "#ffb300" };
    if (listing.isDraft) return { label: "Draft", color: "#9e9e9e" };
    return { label: "Pending", color: "#555" };
  };

  if (loading) return <p style={{ padding: 20 }}>Loading listings...</p>;
  if (error)
    return <p style={{ padding: 20, color: "red" }}>Error: {error}</p>;

  if (listings.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "60px 20px" }}>
        <p style={{ fontSize: 16, color: "#444", marginBottom: 20 }}>
          No shortstay listings found.
        </p>
        <button
          style={styles.addButton}
          onClick={() => navigate(`/shortform1/${userId}`)}
        >
          <AddCircleOutline style={{ marginRight: 8, fontSize: 22 }} />
          Add Listing
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Floating Add Listing Button */}
      <button
        style={styles.floatingAddButton}
        onClick={() => navigate(`/overview/${userId}`)}
      >
        <AddCircleOutline style={{ marginRight: 8, fontSize: 22 }} />
        Add Listing
      </button>

      <div style={styles.grid}>
        {listings.map((listing) => {
          const { label, color } = getStatus(listing);
          return (
            <div key={listing.listingId} style={styles.card}>
              {/* Promote */}
              <div style={styles.featuredBtnWrapper}>
                {/*
                <button
                  onClick={() =>
                    navigate(
                      `/promote/${listing.listingId}?type=shortstay&hostId=${userId}`
                    )
                  }
                  style={{
                    ...styles.promoteButton,
                    background: listing.isPromoted ? "#00c853" : "#ffcb05",
                  }}
                >
                  {listing.isPromoted ? (
                    "Promoted"
                  ) : (
                    <>
                      <Star fontSize="small" style={{ marginRight: 4 }} />
                      Promote Now
                    </>
                  )}
                </button>
                */}

                {listing.isPromoted && listing.featuredRank && (
                  <div style={styles.rankBadge}>
                    <PushPin fontSize="small" style={{ marginRight: 4 }} />
                    {listing.featuredRank.toUpperCase()}
                  </div>
                )}
              </div>

              {/* Image */}
              <div
                onClick={() => navigate(`/roomdetails/${listing.listingId}`)}
                style={styles.imageWrapper}
              >
                <img
                  src={listing.photos?.[0] || "/placeholder.jpg"}
                  alt="Listing"
                  style={styles.image}
                />
              </div>

              {/* Content */}
              <div style={styles.cardContent}>
                <h3 style={styles.title}>
                  {listing.title || "Untitled"}
                </h3>

                {Number.isFinite(listing.rate) ? (
                  <p style={styles.price}>
                    {symbol}
                    {Number(convertRaw(listing.rate ?? 0, "EUR")).toLocaleString()} /{" "}
                    {getRateLabel(listing.rateType)}
                  </p>
                ) : (
                  <p style={styles.price}>Price N/A</p>
                )}

                <span style={{ ...styles.status, background: color }}>
                  {label}
                </span>
              </div>

              {/* Menu */}
              <div
                style={styles.menuIcon}
                onClick={() =>
                  setMenuVisible(
                    menuVisible === listing.listingId
                      ? null
                      : listing.listingId
                  )
                }
              >
                <MoreVert fontSize="small" style={{ color: "#fff" }} />
              </div>

              {menuVisible === listing.listingId && (
                <div style={styles.menu}>
                  <button
                    style={styles.menuButton}
                    onClick={() =>
                      handleAction(listing.listingId, "edit")
                    }
                  >
                    <Edit fontSize="small" style={{ marginRight: 6 }} />
                    Edit
                  </button>

                  {!listing.isPublished ? (
                    <button
                      style={styles.menuButton}
                      onClick={() =>
                        handleAction(listing.listingId, "publish")
                      }
                    >
                      <CheckCircle
                        fontSize="small"
                        style={{ marginRight: 6 }}
                      />
                      Submit for Review
                    </button>
                  ) : (
                    <button style={styles.disabledButton} disabled>
                      <CheckCircle
                        fontSize="small"
                        style={{ marginRight: 6 }}
                      />
                      Published
                    </button>
                  )}

                  <button
                    style={{ ...styles.menuButton, color: "red" }}
                    onClick={() =>
                      handleAction(listing.listingId, "delete")
                    }
                  >
                    <Delete
                      fontSize="small"
                      style={{ marginRight: 6 }}
                    />
                    Delete
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ShortListings;

// ---------- STYLES ----------
const styles: { [key: string]: React.CSSProperties } = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "24px",
    width: "100%",
  },
  card: {
    aspectRatio: "1/1",
    backgroundColor: "#111",
    borderRadius: "20px",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
  },
  featuredBtnWrapper: {
    position: "absolute",
    top: "10px",
    left: "10px",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  promoteButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    border: "none",
    borderRadius: "999px",
    padding: "6px 14px",
    fontWeight: 600,
    fontSize: "12px",
    cursor: "pointer",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },
  rankBadge: {
    background: "#222",
    color: "#fff",
    fontSize: "11px",
    fontWeight: 600,
    padding: "4px 10px",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    textTransform: "uppercase",
  },
  imageWrapper: {
    width: "100%",
    height: "100%",
    flex: 1,
    overflow: "hidden",
    cursor: "pointer",
    position: "relative",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  cardContent: {
    padding: "14px",
    backgroundColor: "#111",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "4px",
    color: "#fff",
  },
  price: {
    fontSize: "14px",
    color: "#ccc",
    marginBottom: "4px",
  },
  status: {
    fontSize: "12px",
    padding: "4px 8px",
    borderRadius: "999px",
    display: "inline-block",
    color: "#000",
    fontWeight: "bold",
    marginTop: "4px",
  },
  menuIcon: {
    position: "absolute",
    top: "12px",
    right: "12px",
    backgroundColor: "rgba(0,0,0,0.7)",
    padding: "6px",
    borderRadius: "50%",
    cursor: "pointer",
  },
  menu: {
    position: "absolute",
    top: "48px",
    right: "12px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    minWidth: "160px",
    zIndex: 10,
  },
  menuButton: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    fontSize: "14px",
    background: "none",
    border: "none",
    textAlign: "left",
    cursor: "pointer",
    width: "100%",
    color: "#222",
  },
  disabledButton: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    fontSize: "14px",
    background: "#f1f5f9",
    border: "none",
    color: "#9ca3af",
    cursor: "not-allowed",
    width: "100%",
  },
  addButton: {
    display: "inline-flex",
    alignItems: "center",
    background: "linear-gradient( #ffffffff, #bf9b30)",
    color: "#000000ff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 22px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
  },
  floatingAddButton: {
    position: "fixed",
    bottom: "30px",
    right: "40px",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    background: "linear-gradient(135deg, #ffffffff, #bf9b30)",
    color: "#000000ff",
    border: "none",
    borderRadius: "6px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
  },
};
